import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import { axiosPrivate } from '../../../../api/axios';
import { Box, Button, Collapse, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Divider, IconButton,
  Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import Header from "../../../../components/Header";
import ZoneBuilder from './zoneBuilder';


const DefineZones = () => {
  const theme = useTheme();
  const [openInstructions, setOpenInstructions] = useState(true);
  const { assessmentID } = useParams();
  const [allZoneData, setAllZoneData] = React.useState();
  const [refresh, setRefresh] = useState(true);
  const [userAddedZoneTemp, setUserAddedZoneTemp] = useState("");
  const [allZoneDataLength, setAllZoneDataLength] = useState();

  // Get zones for this assessment. 
  const getZones = async () => {
    try {
      const response = await axiosPrivate.get(`/zones/${assessmentID}`, {
          withCredentials: true
      });
      const data = await response.data;
      setAllZoneData(data);
      // if (data.length===0) {
      //   setRows(DefaultThreatsList);
      // } else {
      //   setRows(data);
      // }
      setAllZoneDataLength(data.length);
      console.log(data.length);
    } catch (err) {
      // alert("Login Expired.");
      console.error(err);
      // navigate('/login', { state: { from: location }, replace: true });
    }
  };

   const handleAddNewZone = async () => {
        if (setUserAddedZoneTemp) {
          let zoneName = "Zone Name";
          let zoneDescription = "Zone Description";
          let boundaryProtection = { "firewall": false, "router": false, "switch": false, 'dataDiode': false, "other": false };
          let segmentationType = { 'physicalNetwork': false, 'vlan': false, 'sdn': false, 'vpn': false, 'subnetting': false, 'other': false };
          // let securityOperations = "securityOPS"
          let assetTypes = { "applicationServer": false, "controlServer": false, "dataGateway": false, "dataHistorian": false, "fieldio": false, "hmi": false, "ied": false, "jumpHost": false, "plc": false, "rtu": false, "routers": false, "safetyController": false, "vpnServer": false, "workstations": false, 
            "applicationServerQuantity": 0, "controlServerQuantity": 0, "dataGatewayQuantity": 0, "dataHistorianQuantity": 0, "fieldioQuantity": 0, "hmiQuantity": 0, "iedQuantity": 0, "jumpHostQuantity": 0, "plcQuantity": 0, "rtuQuantity": 0, "routersQuantity": 0, "safetyControllerQuantity": 0, "vpnServerQuantity": 0, "workstationsQuantity": 0 };
          let graphObjects = { "nodes": [], "edges": [] };
          let M0801=0;
          let M0936=0;
          let M0915=0;
          let M0949=0;
          let M0913=0;
          let M0948=0;
          let M0947=0;
          let M0800=0;
          let M0946=0;
          let M0945=0;
          let M0802=0;
          let M0953=0;
          let M0803=0;
          let M0942=0;
          let M0808=0;
          let M0941=0;
          let M0938=0;
          let M0950=0;
          let M0937=0;
          let M0804=0;
          let M0935=0;
          let M0934=0;
          let M0805=0;
          let M0806=0;
          let M0816=0;
          let M0932=0;
          let M0807=0;
          let M0931=0;
          let M0930=0;
          let M0928=0;
          let M0809=0;
          let M0810=0;
          let M0927=0;
          let M0926=0;
          let M0811=0;
          let M0922=0;
          let M0944=0;
          let M0924=0;
          let M0921=0;
          let M0812=0;
          let M0954=0;
          let M0813=0;
          let M0920=0;
          let M0814=0;
          let M0817=0;
          let M0919=0;
          let M0951=0;
          let M0918=0;
          let M0917=0;
          let M0818=0;
          let M0916=0;
          let M0815=0;


          let active = true;
    
          // let zoneData = JSON.stringify({ zoneDescription, segmentationType, boundaryProtection, securityOperations, assetTypes });
          let zoneData = JSON.stringify({ zoneName, zoneDescription, segmentationType, boundaryProtection, assetTypes, graphObjects,  });
          // let zoneData = JSON.stringify({
          //   id: `rtr${data[i]._id}`,
          //   position: {x:50, y:150},
          //   data: {label: "Router"},
          //   type: 'default',
          //   parentId: data[i]._id,
          //   extent: 'parent',
          // })
    
          try {
            const response = await axiosPrivate.post(`/zones/new`,
              JSON.stringify({ assessmentID, zoneName, zoneDescription, zoneData, graphObjects, M0801,	M0936,	M0915,	M0949,	M0913,	M0948,	M0947,	M0800,	M0946,	M0945,	M0802,	M0953,	M0803,	M0942,	M0808,	M0941,	M0938,	M0950,	M0937,	M0804,	M0935,	M0934,	M0805,	M0806,	M0816,	M0932,	M0807,	M0931,	M0930,	M0928,	M0809,	M0810,	M0927,	M0926,	M0811,	M0922,	M0944,	M0924,	M0921,	M0812,	M0954,	M0813,	M0920,	M0814,	M0817,	M0919,	M0951,	M0918,	M0917,	M0818,	M0916,	M0815, active }),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            } 
          );
          } catch (err) {
              console.log(err);
          }
          setRefresh(!refresh);
        }
    };

  useEffect(() => {
    getZones();
  }, [refresh]);  // eslint-disable-line react-hooks/exhaustive-deps
  


  const handleOpenInstructions = () => {
    setOpenInstructions(!openInstructions);
  };


  

  console.log(allZoneData);

  
  return (
    <div>
      <Header title='Zones' subtitle='Define your networks or network segments.' />
      <Grid container spacing={2} sx={{ mt:'1rem', pr:'1rem', pb: '1rem', border: 'solid 1px'}}>
        <Grid item xs={12} sx={{ p:'1rem' }}>
          <Paper sx={{ backgroundImage: "none", backgroundColor: theme.palette.background.alt, borderRadius: "0.55rem", mr:'0.55rem', p:'4px'}} >
            <Grid item xs={12} sx={{ p:'0.5rem' }}>
              {openInstructions ? (
              <IconButton color="primary"  aria-label="open or close instructions" onClick={handleOpenInstructions} >
                <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="large" />
                <Typography variant='h3' sx={{ ml: '1.5rem' }}><u>Instructions</u>:</Typography>
              </IconButton>
                ) : (
                <IconButton color="primary"  aria-label="open or close detection and response" onClick={handleOpenInstructions} >
                  <ExpandCircleDownIcon color='primary' fontSize="large" />
                  <Typography variant='h3' sx={{ ml: '1.5rem' }}>Instructions</Typography>
                </IconButton>
                )}
              <Divider sx={{ border:0.5, mt:'6px' }}/>
            </Grid>
            <Collapse in={openInstructions} timeout="auto" unmountOnExit>
              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ ml:'2rem' }}>
                  <Typography>Define your network zones and answer the assessment questions for each zone.</Typography>
                  <Typography>Zones are like network segments. A zone is a group of logical or physical assets with something in common, including, but not limited to, criticality, function, risk, or ownership.</Typography>
                  <Typography>This information will be used to assess threat vectors by zone.</Typography>
                </Grid>
              </Grid>
            </Collapse>
          </Paper>
        </Grid> 
      </Grid>

      <Grid container spacing={2} sx={{ mt:'1rem', pr:'1rem', pb: '1rem', border: 'solid 1px'}}>
        <Grid item xs={12} sx={{ p:'1rem' }}>
          <Typography display="inline">Add a New Zone.</Typography>
          <IconButton color="primary"  aria-label="add a zone" onClick={handleAddNewZone}>
            <AddCircleIcon fontSize="large" />
          </IconButton>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt:'1rem', pr:'1rem', pb: '1rem', border: 'solid 1px'}}>
        
            {allZoneData?.map(
                ({
                  _id,
                  zoneName,
                  zoneData,
                }) => (
                  <Grid item xs={6} sx={{ p:'1rem' }}>
                    <ZoneBuilder
                      key={_id}
                      _id={_id}
                      zoneName={zoneName}
                      zoneData={zoneData}
                      allZoneDataLength={allZoneDataLength}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                    </Grid>
                )
              )}
      </Grid>

    </div>
    
  )
}

export default DefineZones